import type { CSSProperties } from "vue";
import { formatCssDimension } from "./css";
import { convertDeprecatedVariant } from "./variant";

export const allSize = ["xs", "sm", "md", "lg"] as const;
export type Size = (typeof allSize)[number];

export type DeprecatedSizeProps = {
	/**
	 * @deprecated
	 */
	xs?: boolean;

	/**
	 * @deprecated
	 */
	sm?: boolean;

	/**
	 * @deprecated
	 */
	md?: boolean;

	/**
	 * @deprecated
	 */
	lg?: boolean;
};

export function convertDeprecatedSize(props: DeprecatedSizeProps) {
	return convertDeprecatedVariant(allSize, props);
}

export const DeprecatedSizeVariant = ["xSmall", "small", "medium", "large"] as const;
export type DeprecatedSizeVariant = (typeof DeprecatedSizeVariant)[number];
export type DeprecatedSizeVariantProps = {
	/**
	 * @deprecated
	 */
	xSmall?: boolean;

	/**
	 * @deprecated
	 */
	small?: boolean;

	/**
	 * @deprecated
	 */
	medium?: boolean;

	/**
	 * @deprecated
	 */
	large?: boolean;
};

export function convertDeprecatedSizeVariant(props: DeprecatedSizeVariantProps) {
	return convertDeprecatedVariant(DeprecatedSizeVariant, props);
}

export function removeDeprecatedSize(props: DeprecatedSizeProps): Omit<DeprecatedSizeProps, Size> {
	const cleaned: Partial<DeprecatedSizeProps> = { ...props };

	for (const s of allSize) {
		delete cleaned[s];
	}

	return cleaned as any;
}

export type DeprecatedCustomSizeProps = {
	/**
	 * @deprecated
	 */
	width?: string | number;

	/**
	 * @deprecated
	 */
	height?: string | number;

	/**
	 * @deprecated
	 */
	size?: string | number;
};

export function deprecatedSizeToCSS(props: DeprecatedCustomSizeProps): CSSProperties {
	const style: CSSProperties = {};

	const width = props.width || props.size;
	const height = props.height || props.size;

	if (width) {
		style.width = formatCssDimension(width);
	}

	if (height) {
		style.height = formatCssDimension(height);
	}

	return style;
}
